import {basePath} from "./global";

$('body').on('change', 'main.commune-programme-admin #expo-form #discipline-select-dropdown', function (e) {

    let disciplineId = $('#discipline-select-dropdown').val();
    let disciplineText = $('#discipline-select-dropdown option:selected').text();

    $.ajax({
        url: basePath + 'ajax/get-artist-by-discipline-for-programme/',
        method: 'POST',
        data: {disciplineId: disciplineId, disciplineText: disciplineText},
        dataType: "json",
        success: function (data) {
            let html = '<option value="label" selected="selected" disabled>Artiste</option>';
            $(data.artistes).each(function (index, el) {
                html += '<option value="'+el.id+'">'+el.name+'</option>'
            });
            $('#artist-select-dropdown').html(html)
            $("#artist-select-dropdown").select2("destroy");
            $("#artist-select-dropdown").select2();
        }
    })
})


// WEBPACK FOOTER //
// ./src/js/app/commune-programme-admin.js